import { AbyssTheme as themeConfiguration } from '@src/app/browser';
import { ErrorHandler } from '@src/shared/ui/components/ErrorHandler';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import React from 'react';

import { AttributeWidget } from '..';

/**
 * Widget: AttributeSummary
 *
 * Displays Attribute widget for SSN and DOB in same panel.
 *
 * @param options
 * @param riskRecord
 * @returns {Element}
 * @constructor
 */
export function AttributeSummary({ options = {}, riskRecord = {} }) {
  const dobOptions = { ...options, ...{ accessor: 'attribute-summary-dob' } };
  const ssnOptions = { ...options, ...{ accessor: 'attribute-summary-ssn' } };

  return (
    <ErrorHandler location="src/widgets/RiskRecords/AttributeSummary/AttributeSummary.jsx">
      <Layout.Group alignItems="top" alignLayout="left" grow space={Number(themeConfiguration?.theme?.space?.md) || 16}>
        <div style={{ width: '100%' }}>
          <AttributeWidget options={dobOptions} riskRecord={riskRecord} />
        </div>
        <div style={{ width: '100%' }}>
          <AttributeWidget options={ssnOptions} riskRecord={riskRecord} />
        </div>
      </Layout.Group>
    </ErrorHandler>
  );
}
